import via from '@bridge/byted-via-tiktok';
import { isRN } from '@lib/env_detect';
var Store = /** @class */ (function () {
    function Store() {
    }
    Store.prototype.set = function (key, val) {
        var value = JSON.stringify(val);
        return via.app.setNativeItem({
            key: key,
            value: value,
        });
    };
    Store.prototype.get = function (key) {
        return new Promise(function (resolve, reject) {
            via.app
                .getNativeItem({
                key: key,
            })
                .then(function (res) {
                var data = isRN ? JSON.parse(res || '{}') : JSON.parse(res.data || '{}');
                resolve(data);
            })
                .catch(function (err) {
                resolve('');
            });
        });
    };
    // Blanking
    Store.prototype.remove = function (key) {
        return via.app.setNativeItem({
            key: key,
            value: JSON.stringify({}),
        });
    };
    return Store;
}());
var RnStore = new Store();
export default RnStore;
